import { Text } from 'react-native'
import { styled } from '~/core/styled'

import { convertLineHeight, convertPercentageToNumber } from '~/utils'

type BigNumberProps = React.ComponentPropsWithRef<typeof BigNumber>

const BigNumber = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.bold,
      color: theme.colorTextNeutralDefault,

      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      textDecorationLine: theme.textDecorationLineNone,
    },
    variants: {
      variant: {
        'large-bold': {
          fontSize: theme.fontSizeTwelvepulse,
          lineHeight: convertLineHeight(
            theme.fontSizeTwelvepulse,
            theme.lineHeightTiny
          ),
        },
        'default-bold': {
          fontSize: theme.fontSizeTenpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeTenpulse,
            theme.lineHeightTiny
          ),
        },
        'small-bold': {
          fontSize: theme.fontSizeEightpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeEightpulse,
            theme.lineHeightTiny
          ),
        },
      },
    },
  }
})

export { BigNumber }
export type { BigNumberProps }
